/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Claim_Replacement_InvalidInputs */

const en_error_claim_replacement_invalid = /** @type {(inputs: Error_Claim_Replacement_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The replacement is another order of the same customer, and the order made from the claim stays its replacement.`)
};

/**
* | output |
* | --- |
* | "The replacement is another order of the same customer, and the order made from the claim stays its replacement." |
*
* @param {Error_Claim_Replacement_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_claim_replacement_invalid = /** @type {((inputs?: Error_Claim_Replacement_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Claim_Replacement_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_claim_replacement_invalid(inputs)
});